module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container col-md-8 col-sm-8 col-md-offset-2 col-sm-offset-2"
  }, [_c('search-car', {
    on: {
      "input-changed": _vm.selectCar,
      "reset-view": _vm.reset_view,
      "localizar": _vm.localizar_click
    }
  }), _vm._v(" "), (_vm.isProcessing) ? _c('spinner', {
    attrs: {
      "size": 50,
      "line-size": 3,
      "speed": 0.6,
      "line-fg-color": 'magenta',
      "spacing": 6,
      "message": 'Procesando información...',
      "font-size": 18,
      "text-fg-color": '#07088E'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_tracking) ? _c('div', [_c('change-car', {
    attrs: {
      "car": _vm.car,
      "gps": _vm.gps,
      "error-gps": _vm.errorGps,
      "account": _vm.account
    },
    on: {
      "car-change": _vm.carChange,
      "account-change": _vm.accountChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "command-panel"
  }, [(_vm.lastPosition) ? _c('last-position-table', {
    attrs: {
      "timestamp": _vm.lastPosition.timestamp,
      "address": _vm.lastPosition.address,
      "refresh": _vm.refreshCar
    }
  }) : _vm._e(), _vm._v(" "), _c('fuel-cut', {
    attrs: {
      "vehicle": _vm.car
    },
    on: {
      "execution-finished": function($event) {
        return _vm.fuelCutCommandFinished()
      }
    }
  })], 1), _vm._v(" "), _c('maps', {
    attrs: {
      "id": "map",
      "last-car-location": _vm.lastPosition,
      "signals": _vm.currentSignals,
      "markerFocused": _vm.markerToFocus,
      "freshSignals": _vm.finalSignals
    }
  }), _vm._v(" "), _c('tabs', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "tabs": ['Ultimos reportes', 'Comandos de corte: Log']
    }
  }, [_c('location-table', {
    attrs: {
      "slot": "Ultimos reportes",
      "car": _vm.car,
      "current-signals": _vm.currentSignals,
      "rows-per-page": _vm.rowsPerPageTrack
    },
    on: {
      "focus-location": _vm.focusLocation,
      "page-change": _vm.pageChange,
      "clear-dates": _vm.clearDates,
      "change-dates": _vm.changeDates,
      "change-geocode-provider": _vm.changeGeolocalizationProvider
    },
    slot: "Ultimos reportes"
  }), _vm._v(" "), _c('fuel-cut-history', {
    ref: "fuelCutHistory",
    attrs: {
      "slot": "Comandos de corte: Log",
      "vehicle": _vm.car
    },
    slot: "Comandos de corte: Log"
  })], 1), _vm._v(" "), _c('map-link', {
    attrs: {
      "map-link": _vm.mapLink,
      "show-link": _vm.showLink,
      "copying": false
    },
    on: {
      "enable-map-link": _vm.enable_map_link
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-355a4aa2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/TrackCar.vue
// module id = 244
// module chunks = 3